import { defer, Subject } from 'rxjs';

export abstract class MessagesService<T = string> {
  public readonly messages$ = defer(() => this.messagesSource.asObservable());
  protected messagesSource = new Subject<T>();

  queue(message: T): void {
    this.messagesSource.next(message);
  }

  close(): void {
    this.messagesSource.complete();
  }
}
